import { Box, Button, Flex, FormControl, FormLabel, Heading, Input, Stack, useColorModeValue } from '@chakra-ui/react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { urlNavigate } from '../../helper/utils/navigation.js';
import { doCheckEmail } from '../../redux/waiver/waiver.actions.js';

export default function OrderConfirmation() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [email, setEmail] = useState('');
    const handleSubmit = () => {
        const payload = {
            email,
        };

        dispatch(doCheckEmail(payload, navigate));
    };

    return (
        <Flex minH={'100vh'} align={'center'} justify={'center'} bg={useColorModeValue('gray.50', 'gray.800')}>
            <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
                <Stack align={'center'}>
                    <Heading fontSize={'4xl'}>Buy Membership</Heading>
                </Stack>
                <Box rounded={'lg'} bg={useColorModeValue('white', 'gray.700')} boxShadow={'lg'} p={8}>
                    <Stack spacing={4}>
                        <FormControl id='email'>
                            <FormLabel>Email address</FormLabel>
                            <Input type='email' onChange={(e) => setEmail(e?.target.value)} />
                        </FormControl>

                        <Stack spacing={5}>
                            <Button
                                onClick={handleSubmit}
                                bg={'blue.400'}
                                color={'white'}
                                _hover={{
                                    bg: 'blue.500',
                                }}>
                                Buy Membership
                            </Button>
                            <Button onClick={() => navigate(urlNavigate('membership'))} color={'black'}>
                                Back
                            </Button>

                            <Button onClick={() => navigate(urlNavigate('online-sales'))} colorScheme='teal'>
                                Fill Waiver
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </Stack>
        </Flex>
    );
}
